import style from './SubtitleText.module.scss'
import { selectMovie } from '../../../../../redux/movieSlices/MovieSelector'
import { useSelector } from 'react-redux'

let SubtitleText = () => {

    let { movie } = useSelector(selectMovie)

    return (
        <div className={style.subtitle__text}>
            {movie.description_intro}
        </div>
    )
}

export default SubtitleText